import type { CSSProperties } from "react";
import React from "react";
interface IUploadSuccess {
  style?: CSSProperties;
}

const UploadSuccess = ({ style }: IUploadSuccess) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37" fill="none" style={style}>
<path d="M37 0H0V37H37V0Z" fill="white" fillOpacity="0.01"/>
<path d="M18.5002 33.9168C22.7573 33.9168 26.6115 32.1912 29.4014 29.4013C32.1912 26.6115 33.9168 22.7573 33.9168 18.5001C33.9168 14.243 32.1912 10.3888 29.4014 7.5989C26.6115 4.809 22.7573 3.0835 18.5002 3.0835C14.243 3.0835 10.3888 4.809 7.5989 7.5989C4.8091 10.3888 3.0835 14.243 3.0835 18.5001C3.0835 22.7573 4.8091 26.6115 7.5989 29.4013C10.3888 32.1912 14.243 33.9168 18.5002 33.9168Z" fill="#91D0A6" stroke="#91D0A6" strokeWidth="2.91667" strokeLinejoin="round"/>
<path d="M12.3335 18.5L16.9585 23.125L26.2085 13.875" stroke="white" strokeWidth="2.91667" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
);

export default React.memo(UploadSuccess);
